import { SideNavV3 } from './SideNavV3';
import { SideNavHeaderV3 } from './SideNavHeaderV3';
import { SideNavLinkV3 } from './SideNavLinkV3';

SideNavV3.Header = SideNavHeaderV3;
SideNavV3.Link = SideNavLinkV3;

export { SideNavV3 };
